import { useTranslation } from 'react-i18next'

import { z } from '@/lib/zod'

export function EditNewsImageSchema() {
  const { t } = useTranslation()

  return z.object({
    image: z
      .instanceof(File, { message: t('zod:errors.invalid_type') })
      .or(z.array(z.string()))
      .optional()
      .nullable(),
  })
}

export type EditNewsImageForm = z.infer<ReturnType<typeof EditNewsImageSchema>>
